import { FC } from "react";
import { useTranslation } from "react-i18next";
import { LocationSearch, NationalitySelect, SearchSubmit, CheckInOutComponent, GuestSelection } from "../../HotelSearchForm";

const SearchMobileLayout: FC<{ errorFields: string[] }> = ({ errorFields }) => {
  const { t } = useTranslation();
  return (
    <div className="flex w-full flex-col items-start justify-center gap-2 rounded-xl bg-background-default p-4">
      <div className="outline-border-minimal w-full rounded-xl p-4 outline gap-8 flex-col flex px-4">
        <LocationSearch errorFields={errorFields} />
        <CheckInOutComponent errorFields={errorFields} />
        <NationalitySelect errorFields={errorFields} />
        <GuestSelection />
      </div>
      <div className="w-full">
        <SearchSubmit />
      </div>
    </div>
  );
};

export default SearchMobileLayout;
